module.exports = __webpack_public_path__ + "img/3.aeec9c4c.png";